import { Route } from '@angular/router';
import { DeviceDetailConfigService } from '@rogers/self-serve-wireless/device';
import { checkRouterStateGuard } from '@rogers/self-serve-common/guards';
import { WIRELESS_ROUTE } from '@rci/self-serve-fido/app.constant';
import { DeviceDetailConfig } from '@rci/self-serve-fido/wireless/config/device-detail-config';
import { getWirelessDeeplinkGuard } from '@rci/self-serve-fido/guard/routing.guards';

export const deviceDetailRoute: Route = {
  path: `${WIRELESS_ROUTE}/device-details`,
  pathMatch: 'full',
  canActivate: [() => getWirelessDeeplinkGuard(WIRELESS_ROUTE), () => checkRouterStateGuard('wireless')],
  loadComponent: () => import('@rogers/self-serve-wireless/device').then(m => m.DeviceDetailsComponent),
  providers: [
    {
      provide: DeviceDetailConfigService,
      useClass: DeviceDetailConfig,
    },
  ],
};
